import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISetting } from "../settingSlice";

export const getAllSetting = createAsyncThunk(
  "Setting/FindAllSetting",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Setting/FindAllSetting`,
        {
          SettingKey: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createSetting = createAsyncThunk(
  "Setting/InsertSetting",
  async (SettingData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Setting/InsertSetting`,
        SettingData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateSetting = createAsyncThunk(
  "Setting/UpdateSetting",
  async (SettingData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Setting/UpdateSetting`,
        SettingData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Setting :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteSetting = createAsyncThunk(
  "Setting/DeleteSetting",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Setting/DeleteSetting`,
        {
          ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Setting :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getSettingByID = createAsyncThunk(
  "Setting/FindByIDSetting",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Setting/FindByIDSetting`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        SettingKey: result.SettingKey,
        SettingType: result.SettingType,
        SettingValue: result.SettingValue,
        IsActive: result.IsActive ? 1 : 2,
      } as ISetting;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Setting :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveSetting = createAsyncThunk(
  "Setting/FindAllActiveSetting",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Setting/FindAllActiveSetting`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Settinges:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveSetting = createAsyncThunk(
  "Setting/ActiveInActiveSetting",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Setting/ActiveInActiveSetting`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Setting :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
